import axios from "axios";
import { clearAuthSession, getAuthSession, updateAuthSession } from "./auth";

const localApiHosts = new Set(["localhost", "127.0.0.1", "::1"]);

const fallbackBaseUrl = localApiHosts.has(window.location.hostname) ? "http://localhost:5010" : "";

axios.defaults.baseURL = fallbackBaseUrl;

axios.interceptors.request.use((config) => {
  const session = getAuthSession();
  if (session?.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (response?.config?.url === "/api/me" && response?.data?.user) {
      updateAuthSession({
        name: response.data.user.name,
        role: response.data.user.roleLabel || response.data.user.role,
        roleKey: response.data.user.role,
        email: response.data.user.email,
        userId: response.data.user.id,
      });
    }

    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthSession();

      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
